var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#CE2139",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 4.5h-9a.3.3 0 0 0-.3.3v8.4a1.2 1.2 0 0 0 1.2 1.2h7.2a1.2 1.2 0 0 0 1.2-1.2V4.8a.3.3 0 0 0-.3-.3zm-5.55 7.8a.45.45 0 0 1-.9 0V6.9a.45.45 0 1 1 .9 0v5.4zm3 0a.45.45 0 0 1-.9 0V6.9a.45.45 0 1 1 .9 0v5.4zM13.1 2.4h-2.85a.15.15 0 0 1-.15-.15V1.5A1.5 1.5 0 0 0 8.6 0h-3a1.5 1.5 0 0 0-1.5 1.5v.75a.15.15 0 0 1-.15.15H1.1a.6.6 0 1 0 0 1.2h12a.6.6 0 0 0 0-1.2zm-7.8-.15V1.5a.3.3 0 0 1 .3-.3h3a.3.3 0 0 1 .3.3v.75a.15.15 0 0 1-.15.15h-3.3a.15.15 0 0 1-.15-.15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.0c0fd28f0a455165c28841505003b6ee.svg";
export { ForwardRef as ReactComponent };